/**
 * Angular imports.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * constant imports
 */
import { HCF_TEMPLATE_STATUS, HCF_CONNECTION_ID } from '../../constants/app.constants';

/**
 * Modal imports.
 */
import { Target } from '../../onboarding/interface/global.model';

/**
 * HCF outer component.
 */
@Component({
  selector: 'app-hcf-outer',
  templateUrl: './hcf-outer.component.html',
  styleUrls: ['./hcf-outer.component.scss']
})
export class HcfOuterComponent {

  /**
   * Outer hcf information.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() outerInfo: any;

  /**
   * Emit the outer card button cta.
   */
  @Output() emitCtaTarget: EventEmitter<Target> = new EventEmitter();

  /**
   * Emit the template button target.
   */
  @Output() emitOuterCardTarget: EventEmitter<void> = new EventEmitter();

  /**
   * template status
   */
  public templateStatus = HCF_TEMPLATE_STATUS;

  /**
   * hcf template id
   */
  public templateId = HCF_CONNECTION_ID;
  /**
   * Emit the outer card button cta.
   */
  ctaTarget(target: Target): void {
    this.emitCtaTarget.emit(target);
  }

  /**
   * Emit the outer card button cta.
   */
  outerCardTarget(): void {
    this.emitOuterCardTarget.emit();
  }
}
